import menu from "constants/menu.json";
import { useNavigatePage } from "hooks/useNavigatePage";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
import {
  offSideBar,
  offSideMenu,
  onSideMenu,
  selectActiveSideMenu,
  selectSideBar,
  switchSideMenu,
} from "redux/reducers/sideBarReducer";
import { Container, SideMenu, SideMenuContainer, TopMenu } from "./style";
const SideBar = () => {
  const dispatch = useDispatch();
  const nav = useNavigatePage();
  // open sideMenu by topMenu index
  const [clickedTopId, setClickedTopId] = useState(null);
  const sideMenuHandler = (topId) => {
    if (clickedTopId === topId) {
      dispatch(switchSideMenu());
      return;
    }
    setClickedTopId(topId);
    dispatch(onSideMenu());
  };
  // if click not in container close sideBar
  const containerClickHandler = (e) => {
    if (e.target === e.currentTarget) dispatch(offSideBar());
  };

  // on off sideBar
  const sideBarSelector = useSelector(selectSideBar);
  const sideMenuSelector = useSelector(selectActiveSideMenu);

  // when sideBar closed, set init activeSideMenu
  useEffect(() => {
    if (!sideBarSelector) dispatch(offSideMenu());
  }, [sideBarSelector, dispatch]);

  // when clicked sideMenu, nav to url
  const navHandler = (to) => {
    dispatch(offSideBar());
    nav(to);
  };

  // 언어 관련
  const currentLanguage = useSelector(selectLanguage);

  // 공유하기 버튼 클릭 handler
  const shareHandler = async () => {
    const shareData = {
      title: "Sketch 홈페이지 공유",
      text: "Sketch 홈페이지를 공유합니다!",
      url: window.location.href,
    };
    // 모바일 웹뷰 안드로이드는 지원안함 (카카오, 네이버 자체 브라우저 인듯)
    // ssl 적용되어 있어야만 실행 가능
    if (window.navigator.share) {
      window.navigator
        .share(shareData)
        .then(() => alert("공유 성공"))
        .catch((e) => alert("공유 취소"));
    } else {
      alert("공유하기가 지원되지 않는 환경입니다.");
    }
  };
  return (
    <>
      {sideBarSelector && (
        <Container onClick={containerClickHandler}>
          {menu.data.map((top) => (
            <div key={top.id}>
              {/* Top Menu */}
              <TopMenu onClick={() => sideMenuHandler(top.id)} isActive={clickedTopId === top.id && sideMenuSelector}>
                <span>{currentLanguage === "en" ? top.title : top.titleKR}</span>
                <img loading="lazy" src="/assets/img/Header_5.svg" alt="" />
              </TopMenu>

              {/* Side Menu */}
              <SideMenuContainer>
                {clickedTopId === top.id &&
                  sideMenuSelector &&
                  top.sideMenus.map(
                    (side) =>
                      side.status === 1 && (
                        <SideMenu
                          key={side.id}
                          onClick={() => {
                            navHandler(side.url);
                          }}
                        >
                          {currentLanguage === "en" ? side.title : side.titleKR}
                        </SideMenu>
                      ),
                  )}
              </SideMenuContainer>
            </div>
          ))}
          {/* <ShareBtn onClick={shareHandler}>
            <img loading="lazy"  src="/assets/img/Header_8.svg" alt="" />
            <span>공유하기</span>
          </ShareBtn> */}
        </Container>
      )}
    </>
  );
};

export default SideBar;
